import React from "react";
import PageLayout from "../../components/Clearith/PageLayout";
import {
  AccessibilityContent,
  FundingContent,
  LegalContent,
  PedagogyContent,
  PrivacyContent,
} from "../../components/Clearith/InformationContent";

export const PedagogyPage: React.FC = () => (
  <PageLayout title="Méthode pédagogique" breadcrumb="Méthode pédagogique">
    <PedagogyContent />
  </PageLayout>
);

export const FundingPage: React.FC = () => (
  <PageLayout title="Financement" breadcrumb="Financement">
    <FundingContent />
  </PageLayout>
);

export const AccessibilityPage: React.FC = () => (
  <PageLayout title="Accessibilité" breadcrumb="Accessibilité">
    <AccessibilityContent />
  </PageLayout>
);

export const LegalPage: React.FC = () => (
  <PageLayout title="Mentions légales" breadcrumb="Mentions légales">
    <LegalContent />
  </PageLayout>
);

export const PrivacyPage: React.FC = () => (
  <PageLayout
    title="Politique de confidentialité"
    breadcrumb="Confidentialité"
  >
    <PrivacyContent />
  </PageLayout>
);
